import Tags from './Tags'
import Home from './Home'
import Error from './Error'
import Categories from './Categories'

export {
    Tags,
    Home,
    Error,
    Categories
}
